import LiveDataOverLDSWrapper from './LiveDataOverLDSWrapper';

export default LiveDataOverLDSWrapper;
